/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserActivityUserId } from './userActivityUserId';
import type { UserActivityType } from './userActivityType';
import type { UserActivityCourseId } from './userActivityCourseId';
import type { UserActivityModuleId } from './userActivityModuleId';
import type { UserActivityTaskId } from './userActivityTaskId';
import type { UserActivityImpersonatedBy } from './userActivityImpersonatedBy';
import type { UserActivityData } from './userActivityData';

/**
 * Stores a recent activity of a user
 */
export interface UserActivity {
  userId?: UserActivityUserId;
  timestamp?: string;
  activity: UserActivityType;
  courseId?: UserActivityCourseId;
  moduleId?: UserActivityModuleId;
  taskId?: UserActivityTaskId;
  impersonatedBy?: UserActivityImpersonatedBy;
  data?: UserActivityData;
}
